import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Navigate } from "react-router-dom";
import { useToggle } from "react-use";
import PropTypes from "prop-types";
import { Button, Dialog, DialogContent, DialogContentText, DialogActions } from "@material-ui/core";
import { logout } from "../../actions/authActions";

const UploadBlockedDialog = ({ correctRA, blockReason, showModal, onCloseAction }) => {
  const onClose = () => onCloseAction();
  const [dialogText, setDialogText] = useState("");
  const [actionText, setActionText] = useState("");
  const [showActionButton, toggleShowActionButton] = useToggle(false);

  const dispatch = useDispatch();
  const forceLogout = () => {
    dispatch(logout());
    return <Navigate to={`/login?raNumber=${correctRA}`} />;
  };

  const resetStates = () => {
    setDialogText("");
    setActionText("");
    toggleShowActionButton(false);
  };

  const getActionStates = (reason) => {
    switch (reason) {
      case "blocked-location-service":
        setActionText("");
        setDialogText(
          "It looks like your location is disabled. Please enable your location services to proceed to upload the photos."
        );
        toggleShowActionButton(false);
        return;

      case "incorrect-ra":
        setActionText("Login with correct RA number");
        setDialogText(
          "It looks like you're logged in with a diffrent rental agreement number. Please follow this link to logout, and log back in with this rental agreement number to upload new photos for this rental."
        );
        toggleShowActionButton(true);
        return;

      default:
        resetStates();
        return;
    }
  };
  useEffect(() => {
    getActionStates(blockReason);
  }, [blockReason]);

  return (
    <Dialog
      open={showModal}
      onClose={onClose}
      onBackdropClick={onClose}
      onEscapeKeyDown={onClose}
      PaperProps={{
        style: {
          backgroundColor: "#A00",
        },
      }}
    >
      <DialogContent>
        <DialogContentText>
          <span style={{ color: "#FFF" }}>{dialogText}</span>
        </DialogContentText>
        <DialogActions>
          {showActionButton && (
            <Button
              variant="contained"
              autoFocus
              onClick={forceLogout}
              color="primary"
              style={{ fontWeight: "bold" }}
            >
              {actionText}
            </Button>
          )}
          <Button
            variant="contained"
            autoFocus
            onClick={onClose}
            color="primary"
            style={{ fontWeight: "bold" }}
          >
            Close
          </Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
};

UploadBlockedDialog.propTypes = {
  correctRA: PropTypes.string.isRequired,
  dialogText: PropTypes.string.isRequired,
  showModal: PropTypes.bool,
  onCloseAction: PropTypes.func,
};

UploadBlockedDialog.defaultProps = {
  showModal: false,
  onCloseAction: () => undefined,
};

export default UploadBlockedDialog;
